<template>
    <form :inert="isLoading" :class="{'ajax_processed': isLoading}" @submit.prevent="onSubmit">
        <div class="bl_reg_form clearfix">
            <div class="form_row form-item required" :class="{'error': v$.formData.cardNum.$errors.length}">
                <label for="discount-change-card" class="control-label">Номер карты <span class="req">*</span></label>
                <input id="discount-change-card" type="text" class="form-control form-item required" v-model="formData.cardNum" data-mask-card>
            </div>
            <div class="form_row form-item required" :class="{'error': v$.formData.name.$errors.length}">
                <label for="discount-change-fio" class="control-label">Ф.И.О. <span class="req">*</span></label>
                <input id="discount-change-fio" type="text" class="form-control form-item required" v-model="formData.name">
            </div>
            <div class="form_row form-item required" :class="{'error': v$.formData.phone.$errors.length}">
                <label for="discount-change-phone" class="control-label">Телефон <span class="req">*</span></label>
                <input id="discount-change-phone" type="text" class="form-control form-item required" v-model="formData.phone" data-mask-phone>
            </div>
            <div class="form_row form-item required" :class="{'error': v$.formData.email.$errors.length}">
                <label for="discount-change-email" class="control-label">E-mail <span class="req">*</span></label>
                <input id="discount-change-email" type="text" class="form-control form-item required" v-model="formData.email">
            </div>
            <div class="form_row required">
                <label>Документ <span class="asterisk">*</span></label>

                <div v-for="(field, i) in fileFields" :key="field.id" class="bl_input_file" :class="{'bl_input_file--add': i !== 0}">
                    <template v-if="i === 0">
                        <input type="hidden" value="">
                        <input type="file" class="input-file" @change="($event) => onUploadFile(field.id, $event)">
                        <input type="text" class="filename"> <span>Обзор</span>
                    </template>
                    <template v-else>
                        <input type="hidden" value="">
                        <input type="file" class="input-file" @change="($event) => onUploadFile(field.id, $event)">
                        <input type="text" class="filename"><span>Обзор</span>
                        <span class="form_file_delete_link" @click="onDeleteFileField(field.id)">Удалить</span>
                    </template>
                </div>
                <div class="bl_attention_file">Прикрепите фото любого документа, позволяющего установить ФИО и дату рождения владельца карты</div>
                <button type="button" class="form_file_add_link btn btn_blue" @click="onAddFileField">Добавить ещё</button>
            </div>
            <div class="consent-accepted" v-if="confirmConsent">Согласие на обработку персональных данных принято</div>
        </div>

        <div v-if="!confirmConsent" class="confirm-consent confirm-consent--discount">
            <div class="confirm-consent__text">
            Подтвердите <a href="/upload/Согласие.pdf" target="_blank">согласие</a> на обработку <br> Ваших персональных данных
            </div>
            <div class="confirm-consent__btn">
            <button class="btn btn_red" type="button" @click="confirmConsent = true">Подтвердить</button>
            </div>
        </div>
        <div v-else class="consent-block consent-block--discount">
            <div class="consent-final__text">
            Нажимая кнопку, Вы подтверждаете, что ознакомились с <a href="/upload/Политикa-конфиденциальности.pdf" target="_blank">Политикой конфиденциальности</a>
            </div>
            <div class="consent-final__btn">
            <div class="not-theme" >
                <input type="submit" name="iblock_submit" value="Отправить" class="btn btn_red" >
            </div>
            </div>
        </div>
    </form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {useVuelidate} from '@vuelidate/core'
import {required, email, helpers, minLength} from '@vuelidate/validators'
import initMasks from '../../utils/masks.js';
const {withMessage} = helpers;
import {objectToFormData} from '../../utils/objectToFormData.js';

export default {
    name: 'DiscountPhoneChangeForm',
    props: {
        items: {
            type: Object,
            default: () => ([]),
        }
    },
    setup() {
        return {v$: useVuelidate(), initMasks}
    },
    data: () => ({
        formData: {
            cardNum: '',
            name: '',
            email: '',
            phone: '',
            files: [],
        },
        fileFieldsCounter: 1,
        fileFields: [{id: 0, file: null}],
        isLoading: false,
        confirmConsent: false,
    }),
    validations() {
        return {
            formData: {
                cardNum: {
                    required: withMessage('Обязательное поле', required),
                    custom: withMessage('Обязательное поле', (value) => value.replace(/\D+/g, "").length === 13),
                },
                name: {
                    required: withMessage('Обязательное поле', required)
                },
                phone: {
                    required: withMessage('Обязательное поле', required),
                    minLength: withMessage('Введите корректный телефон', minLength(18)),
                },
                email: {
                    required: withMessage('Обязательное поле', required),
                    email: withMessage('Введите корректный e-mail', email),
                }
            }
        }
    },
    mounted() {
        this.initMasks();
    },
    computed: {
        ...mapGetters({
            getYandexSiteKey: 'getYandexSiteKey',
        })
    },
    watch: {},
    methods: {
        onAddFileField() {
          this.fileFields.push({id: this.fileFieldsCounter++, file: null})
        },
        onUploadFile(id, e) {
            const field = this.fileFields.find(el => el.id === id);
            if (field) {
                field.file = e.target.files[0];
            }
        },
        onDeleteFileField(id) {
            this.fileFields = this.fileFields.filter(el => el.id !== id);
        },
        async onSubmit() {
            const isValid = await this.v$.$validate();
            if (!isValid) return
            this.isLoading = true;
            const isCaptchaStarted = await this.executeYandexCaptcha(() => this.sendForm());
            if (!isCaptchaStarted) {
                this.isLoading = false;
                window.showHeaderMessage('Не удалось загрузить проверку. Перезагрузите страницу и попробуйте ещё раз.', 'error');
            }
        },
        clearForm() {
            this.v$.$reset();
            this.formData = {
                cardNum: '',
                name: '',
                email: '',
                phone: '',
            };
            this.fileFields = [{id: this.fileFieldsCounter++, file: null}]
            this.confirmConsent = false;
        },
        async sendForm() {
            try {
                const files = this.fileFields.map(field => field.file);
                const payload = {...this.formData, files: files, yatoken: window.smartCaptcha.getResponse()}
                const result = await fetch('/api/forms/update-phone-card/', {
                    method: 'POST',
                    body: objectToFormData(payload),
                });
                const data = await result.json();
                if (data.success) {
                    window.showHeaderMessage('Заявка успешно отправлена');
                    this.clearForm();
                } else {
                    window.showHeaderMessage(data.error || 'Произошла ошибка', 'error');
                }
            } catch (error) {
                window.showHeaderMessage(error || 'Произошла ошибка', 'error');
            } finally {
                this.isLoading = false;
            }
        },
        ...mapActions({
            'executeYandexCaptcha': 'executeYandexCaptcha',
        }),
    },
}
</script>
